import { z } from 'zod'

/**
 * Who gets a signer their link: PixelSign by email, or the caller, which hands
 * it to them itself (usually embedded in its own portal) and gets no invite,
 * reminder, question, or cancellation email sent to that signer.
 */
export const SIGNER_DELIVERIES = ['email', 'caller'] as const

export const signerDeliverySchema = z.enum(SIGNER_DELIVERIES)

export type SignerDelivery = z.infer<typeof signerDeliverySchema>

export const PRISMA_SIGNER_DELIVERIES = ['EMAIL', 'CALLER'] as const

export type PrismaSignerDelivery = (typeof PRISMA_SIGNER_DELIVERIES)[number]

export const SIGNER_DELIVERY_FROM_PRISMA = {
  EMAIL: 'email',
  CALLER: 'caller',
} as const satisfies Record<PrismaSignerDelivery, SignerDelivery>

export const SIGNER_DELIVERY_TO_PRISMA = {
  email: 'EMAIL',
  caller: 'CALLER',
} as const satisfies Record<SignerDelivery, PrismaSignerDelivery>
